import { render, staticRenderFns } from "./CustomerHubActivityRecording.vue?vue&type=template&id=448af5d3&scoped=true"
import script from "./CustomerHubActivityRecording.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivityRecording.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivityRecording.vue?vue&type=style&index=0&id=448af5d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448af5d3",
  null
  
)

export default component.exports